import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type TeamActionResponse = APIResponse<'/api/v4/teams/{teamId}/actions'>;

export const fetchTeamActionsInfo = async (teamId: string) =>
  get<TeamActionResponse>(`/v4/teams/${teamId}/actions`);
